export interface CalendarDeleteTarget {
  sourceId: string;
  rowId: string;
  occurrenceStart: string | null;
  readonly: boolean;
  externalReadonly: boolean;
}

/** The source workflow owns confirmation and mutations; this adapter only owns local keyboard input. */
export function handleCalendarDeleteKey(input: {
  key: KeyboardEvent;
  selection: CalendarDeleteTarget | null;
  confirmationOpen: boolean;
  requestDelete: (target: CalendarDeleteTarget) => Promise<void>;
}): boolean {
  const { key, selection, confirmationOpen, requestDelete } = input;
  if (
    (key.key !== 'Backspace' && key.key !== 'Delete') ||
    key.defaultPrevented ||
    key.isComposing ||
    key.repeat ||
    key.metaKey ||
    key.ctrlKey ||
    key.altKey ||
    key.shiftKey ||
    confirmationOpen ||
    !selection ||
    selection.readonly ||
    selection.externalReadonly
  )
    return false;
  const path = key.composedPath();
  if (key.target && !path.includes(key.target)) path.push(key.target);
  if (
    path.some(
      target =>
        target instanceof Element &&
        (target.matches('input,textarea,select') ||
          target.closest(
            'input,textarea,select,[contenteditable]:not([contenteditable="false"])'
          ) ||
          (target instanceof HTMLElement && target.isContentEditable))
    )
  )
    return false;
  const target = Object.freeze({ ...selection });
  key.preventDefault();
  key.stopPropagation();
  // Each host reports errors through its existing source workflow, never an unhandled key promise.
  try {
    void requestDelete(target).catch(() => {});
  } catch {
    /* The source workflow owns its error presentation. */
  }
  return true;
}
